import { Controller } from '@hotwired/stimulus'
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["submit"]

  reenableSubmit() {
    Rails.enableElement(this.submitTarget)
  }
}
